var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { Association } from '../Association/Association';
import { custom, deserialize, disgardOldValue, list, object, primitive, withDefault } from '../../../utils/serializr/serializr';
import { alias } from '../../../utils/serializr/schema/middle/alias';
import { AssociateOption } from '../AssociateOption/AssociateOption';
import { legacy } from '../../../utils/serializr/schema/outer/legacy';
import { editable } from '../../../utils/mobx/decorators/editable';
import { MultipleChoiceStore } from '../../MultipleChoice/modules/MultipleChoiceStore';
import { AssociateLegacy } from './AssociateLegacy';
export class AssociateStore extends MultipleChoiceStore {
    fadeOut = 0;
    askNum = 0;
    allAssociations = observable.array();
    constructor({ parent }) {
        super({ parent });
        makeObservable(this);
    }
    get associateLegacy() {
        return new AssociateLegacy(this);
    }
    get question() {
        return this.parent;
    }
    get destNum() {
        return this.numberOfOptions;
    }
    set destNum(destNum) {
        this.numberOfOptions = destNum;
    }
    get legacyImages() {
        return undefined;
        return this.associateLegacy.legacyImages;
    }
    set legacyImages(l) {
        if (!l)
            return;
        this.associateLegacy.legacyImages = l;
    }
    get legacyComments() {
        return undefined;
        return this.associateLegacy.legacyComments;
    }
    set legacyComments(l) {
        if (!l)
            return;
        this.associateLegacy.legacyComments = l;
    }
    static fromSerialized(ser = {}) {
        return deserialize(AssociateStore, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                allAssociations: withDefault(list(object(Association, { parentDepth: 2 })), []),
                allOptions: withDefault(list(object(AssociateOption, { parentDepth: 2 })), [{}, {}, {}, {}, {}, {}, {}, {}, {}]),
                fadeOut: true,
                destNum: true,
                askNum: true,
                numberOfTries: withDefault(primitive, 1),
                option1: legacy(alias('text1', disgardOldValue(primitive))),
                option2: legacy(alias('text2', disgardOldValue(primitive))),
                option3: legacy(alias('text3', disgardOldValue(primitive))),
                option4: legacy(alias('text4', disgardOldValue(primitive))),
                option5: legacy(alias('text5', disgardOldValue(primitive))),
                option6: legacy(alias('text6', disgardOldValue(primitive))),
                option7: legacy(alias('text7', disgardOldValue(primitive))),
                option8: legacy(alias('text8', disgardOldValue(primitive))),
                option9: legacy(alias('text9', disgardOldValue(primitive))),
                legacyComments: legacy(disgardOldValue(custom(a => a, a => a))),
                legacyImages: legacy(disgardOldValue(custom(a => a, a => a))),
            },
        };
    }
}
__decorate([
    editable()
], AssociateStore.prototype, "fadeOut", void 0);
__decorate([
    editable('ref')
], AssociateStore.prototype, "askNum", void 0);
__decorate([
    editable('shallow')
], AssociateStore.prototype, "allAssociations", void 0);
__decorate([
    memoize
], AssociateStore.prototype, "associateLegacy", null);
__decorate([
    computed
], AssociateStore.prototype, "destNum", null);
__decorate([
    computed
], AssociateStore.prototype, "legacyImages", null);
__decorate([
    computed
], AssociateStore.prototype, "legacyComments", null);
__decorate([
    memoize
], AssociateStore, "serializeInfo", null);
